import React, { lazy } from 'react';
import { type Route, type Routes, useRouter } from 'react-resource-router';
import { componentWithSuspense } from '../../utils';
import { AppAccessGate } from '../AppAccessGate';

import type { GraphClawHubView } from '../../pages/graphclaw-hub/types';

const GraphClawHubPage = lazy(
	() =>
		import(
			/* webpackChunkName: "@atlaskit-internal_dtac-graphclaw-hub" */ '../../pages/graphclaw-hub'
		),
);

const viewByRouteName: Record<string, GraphClawHubView> = {
	'graphclaw-hub': 'apps',
	'graphclaw-hub-my-inference': 'my-inference',
	'graphclaw-hub-my-inference-app': 'app-detail',
	'graphclaw-hub-dashboard': 'dashboard',
	'graphclaw-hub-registry': 'registry',
	'graphclaw-hub-try-it': 'try-it',
	'graphclaw-hub-audit-log': 'audit-log',
};

const GraphClawHubPageWithAccess = (): React.JSX.Element => {
	const [{ route }] = useRouter();

	return (
		<AppAccessGate appName="Labs">
			<GraphClawHubPage view={viewByRouteName[route.name] ?? 'apps'} />
		</AppAccessGate>
	);
};

const graphClawHubRouteComponent = componentWithSuspense(GraphClawHubPageWithAccess);

const ROUTE_PREFIX = '/graphclaw-hub' as const;

const graphClawHubRoutesObject: Record<string, Route> = {
	home: {
		name: 'graphclaw-hub',
		path: ROUTE_PREFIX,
		exact: true,
		component: graphClawHubRouteComponent,
	},
	myInference: {
		name: 'graphclaw-hub-my-inference',
		path: `${ROUTE_PREFIX}/my-inference` as const,
		exact: true,
		component: graphClawHubRouteComponent,
	},
	myInferenceApp: {
		name: 'graphclaw-hub-my-inference-app',
		path: `${ROUTE_PREFIX}/my-inference/:appId` as const,
		exact: true,
		component: graphClawHubRouteComponent,
	},
	dashboard: {
		name: 'graphclaw-hub-dashboard',
		path: `${ROUTE_PREFIX}/dashboard` as const,
		exact: true,
		component: graphClawHubRouteComponent,
	},
	registry: {
		name: 'graphclaw-hub-registry',
		path: `${ROUTE_PREFIX}/registry` as const,
		exact: true,
		component: graphClawHubRouteComponent,
	},
	tryIt: {
		name: 'graphclaw-hub-try-it',
		path: `${ROUTE_PREFIX}/try-it` as const,
		exact: true,
		component: graphClawHubRouteComponent,
	},
	auditLog: {
		name: 'graphclaw-hub-audit-log',
		path: `${ROUTE_PREFIX}/audit-log` as const,
		exact: true,
		component: graphClawHubRouteComponent,
	},
};

export const graphClawHubRoutes: Routes = Object.values(graphClawHubRoutesObject);
